import React from 'react'
import { Card, CardHeader, Modal, IconButton, CardContent, Typography } from '@mui/material'
import { BiX } from 'react-icons/bi'
import { Alerts, ButtonLoading, InputText } from '../../Simple'
import { CheckoutContext } from '../../../contexts/CheckoutContext'

import './stylesAC.css'

export default function AddCupom({ show, onClose }) {
  const { sttCtxChkt, actionsChkt, loadCh } = React.useContext(CheckoutContext)

  const cupomAtive =
    (sttCtxChkt.selTotal || sttCtxChkt.selSinal) &&
    (sttCtxChkt.selPix || sttCtxChkt.selCardCredit || sttCtxChkt.selDinheiro || sttCtxChkt.selMaqCredit)

  const [inpCupom, setInpCupom] = React.useState('')

  function ActionModal() {
    if (sttCtxChkt.cupomAplicado !== null) {
      Alerts.question('Aviso', 'Deseja realmente remover o cupom de desconto?', () => {
        actionsChkt.RemoverCupom()
        setInpCupom('')
        onClose()
      })
    } else {
      actionsChkt.VerificarCupom(inpCupom).then(res => {
        if (res) {
          setInpCupom('')
          onClose()
        }
      })
    }
  }

  function ActiveButton() {
    if (sttCtxChkt.cupomAplicado !== null) return false
    if (!inpCupom.length) return true
    if (!cupomAtive) return true
    return false
  }

  return (
    <Modal open={show} onClose={onClose} className='contain-overlay-obs'>
      <Card className='contain-content-obs'>
        <CardHeader
          classes={{ action: 'card-header-action' }}
          sx={{ padding: '5px' }}
          action={
            <IconButton aria-label='close' className='icon-close-modal' onClick={onClose} style={{ margin: '5px 10px 0px 0px' }}>
              <BiX size={30} />
            </IconButton>
          }
          title={
            <Typography variant='h6' component='div' className='card-header-title'>
              Adicionar Cupom
            </Typography>
          }
        />
        <CardContent sx={{ width: '100%', padding: '5px' }}>
          <Typography color='textSecondary' component='h4' className='text-label-AC'>
            Digite o código do cupom de desconto que você deseja aplicar
          </Typography>
          <InputText
            fullWidth
            label='Código'
            value={inpCupom}
            disabled={!cupomAtive}
            placeholder='Digite aqui sseu código'
            onChange={e => setInpCupom(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') ActionModal()
            }}
          />
          <ButtonLoading
            fullWidth
            label='Aplicar Cupom'
            loading={loadCh.cupom}
            disabled={ActiveButton()}
            sx={{ marginTop: '5px' }}
            onClick={() => {
              ActionModal()
            }}
          >
            {sttCtxChkt.cupomAplicado !== null ? 'Remover Cupom' : 'Aplicar Cupom'}
          </ButtonLoading>
          {!cupomAtive && (
            <Typography color='textSecondary' component='h4' className='text-label-AC' sx={{ marginTop: '5px' }}>
              Para aplicar um cupom, selecione o método de pagamento e a forma de pagamento.
            </Typography>
          )}
        </CardContent>
      </Card>
    </Modal>
  )
}
